const config = {
  baseURL:
    process.env.REACT_APP_API_URI_BASE ??
    "https://samplereception-api-ut.bvna.com",
};

export default config;
